import React from 'react';
import { NotificationContainer } from 'react-notifications';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/authContext';
import history from './history';

// Pages
import Availabilities from './pages/Availabilities';
import EditAccount from './pages/EditAccount';
import Enrollment from './pages/Enrollment';
import MyGames from './pages/MyGames';
import Login from './pages/Login';
import Notifications from './pages/Notifications';
import Substitutions from './pages/Substitutions';
import Ranking from './pages/Ranking';
import SideMenu from './components/SideMenu';
import OtherGames from "./pages/OtherGames";
import OtherLeagues from "./pages/OtherLeagues";
import About from "./pages/About";
import Schedule from "./pages/Schedule";

// CSS Files
import './bootstrap.css';
import 'react-notifications/lib/notifications.css';
import './index.css';

const PrivateRoutes = (props) => {
  const auth = useAuth();

  if (!auth.checked)
    return null;

  if (!auth.user)
    return <Redirect to={{
      pathname: '/login',
      state: { from: props.location.pathname }
    }}/>;

  return <Switch>{props.children}</Switch>;
};

const AppWrapper = (props) => {
  const auth = useAuth();

  return <div className={auth.user ? 'padding-side-menu app-wrapper' : 'app-wrapper'}>
    {!!auth.user && <SideMenu/>}
    {props.children}
  </div>;
};

export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: null,
      modal_visible: false
    };

    window.App = this;
  }

  render() {
    return <AuthProvider>
      <Router history={history}>
        <AppWrapper>
          <Switch>
            <Route path="/enrollment" component={Enrollment}/>
            <Route exact path="/login" render={(props) => <Login {...props}/>}/>

            <PrivateRoutes>
              <Route path="/schedule" component={Schedule}/>
              <Route path="/my-games" component={MyGames}/>
              <Route path="/availabilities" component={Availabilities}/>
              <Route path="/ranking" render={(props) => <Ranking {...props} />}/>
              <Route path="/notifications" component={Notifications}/>
              <Route exact path="/edit-account" component={EditAccount}/>
              <Route path="/substitutions" component={Substitutions}/>
              <Route exact path="/other-games" component={OtherGames}/>
              <Route path="/other-leagues" component={OtherLeagues}/>
              <Route exact path="/about-us" component={About}/>
              <Redirect to={'/schedule'}/>
            </PrivateRoutes>
          </Switch>
        </AppWrapper>
      </Router>

      <NotificationContainer/>
    </AuthProvider>;
  }
}
